const jwtHeader = (header = { 'Content-Type': 'application/json' }) => {
  return {
    ...header, 'X-CSRF-Token': document
      .querySelector("meta[name='csrf-token']")
      .getAttribute('content')
  }
}

export default jwtHeader